<template>
    <div>خطای 404، چیزی یافت نشد.</div>
</template>

<script>
    export default {};
</script>
